import React from 'react';

const Analytics = () => {
  return (
    <div className="text-center py-8 text-gray-500">
      <p>Analytics visualization coming soon...</p>
    </div>
  );
};

export default Analytics;
